// actions.js
export const SET_AUTH = 'SET_AUTH';

 
export const setUserAuth = (detail) => ({
    type: SET_AUTH,
    payload:  {detail} ,
}); 